module.exports = __webpack_public_path__ + "assets/img/first.82b14524.png";